module.exports = __webpack_public_path__ + "img/FO.21980edf.svg";